import {accessToken} from '@/libs/httpAccessVue'
class socket {
  /*url*/
  ws = null
  /*状态 链接状态*/
  _alive = false
  /*类参数*/
  _params = null
  /*计时器*/
  _reconnect_timer = null
  /*心跳计时器*/
  _heart_time = null
  /*信息 onmessage */
  _message_func = null

  _heart_func = null

  _init_func = null

  heartBeat = 30000

  /*心跳信息*/
  heartMsg = 'ping'

  reconnect = true

  lockReconnect = false

  reconnectTime = 5000

  reconnectTimes = 10

  messageCache = []

  token = null

  _token_func = null

  constructor(params) {
    if (this._heart_time) {
      clearInterval(this._heart_time)
      this._heart_time = null
    }
    if (this._reconnect_timer){
      clearInterval(this._reconnect_timer)
      this._reconnect_timer = null
    }
    this._params = params
    this.init()
  }

  init() {
    // 确保清理旧的定时器和连接
    if (this._reconnect_timer){
      clearInterval(this._reconnect_timer)
      this._reconnect_timer = null
    }
    if (this._heart_time) {
      clearInterval(this._heart_time)
      this._heart_time = null
    }

    let params = this._params
    let {url, port} = params
    let global_params = ['heartBeat', 'heartMsg', 'reconnect', 'reconnectTime', 'reconnectTimes', '_message_func', '_heart_func','_init_func','token','_token_func']

    Object.keys(params).forEach(key => {
      if (global_params.indexOf(key) !== -1) {
        this[key] = params[key]
      }
    })

    let ws_url = port ? url + ':' + port : url
    
    // 确保关闭旧连接
    if (this.ws) {
      try {
        this.ws.close()
      } catch (e) {
        console.error('close websocket error:{}', e)
      }
      delete this.ws
      this.ws = null
    }
    
    if (this._token_func) {
      this.token = this._token_func()
    }
    try {
      this.ws = this.token ?  new WebSocket(ws_url, [this.token]) : new WebSocket(ws_url)
    }catch (e) {
      console.error('connect websocket error:{}',e)
      this.lockReconnect = false
      return
    }

    if (this._message_func) {
      this.onmessage(this._message_func)
    }

    this.ws.onopen = () => {
      this.open()
      // 连接成功时清理消息缓存
      this.messageCache = []
    }
    if (!this._message_func) {
      this.ws.onmessage = data => {
        // 限制消息缓存大小，避免内存溢出
        if (this.messageCache.length >= 100) {
          // 移除最旧的一半消息，而不是只移除一条
          this.messageCache = this.messageCache.slice(-50)
        }
        this.messageCache.push(data)
      }
    }
    this.ws.onclose = (e) => {
      this._alive = false
      this.lockReconnect = false
      if (this._heart_time) {
        clearInterval(this._heart_time)
        this._heart_time = null
      }

      if (true === this.reconnect) {
        this.onreconnect()
      }
    }

    this.ws.onerror = (e)=>{
      this.lockReconnect = false
      this._alive = false
      if (this._heart_time) {
        clearInterval(this._heart_time)
        this._heart_time = null
      }
      if (true === this.reconnect) {
        this.onreconnect()
      }
    }
  }

  // 添加打开超时计时器引用，用于清理
  _open_timeout = null

  open() {
    // 如果已经连接或正在关闭，不再尝试
    if (!this.ws || this.ws.readyState === WebSocket.OPEN) {
      this.openInit()
      return
    }
    if (this.ws.readyState === WebSocket.CONNECTING) {
      // 正在连接中，添加超时保护
      if (this._open_timeout) {
        clearTimeout(this._open_timeout)
      }
      this._open_timeout = setTimeout(() => {
        // 超时后强制触发
        if (this.ws && this.ws.readyState !== WebSocket.OPEN) {
          this.openInit()
        }
      }, 5000) // 5秒超时
    } else {
      this.openInit()
    }
  }

  openInit() {
    this._alive = true
    if (this._reconnect_timer) {
      this.lockReconnect = false
      clearInterval(this._reconnect_timer)
      this._reconnect_timer = null
    }
    if (this._init_func) {
      this._init_func(this)
    }
    this.onheartbeat(this._heart_func)
  }
  /*心跳*/
  onheartbeat(func) {
    if (true === this._alive) {
      this._heart_time = setInterval(() => {
        this.send(this.heartMsg)
        func ? func(this) : false
      }, this.heartBeat)
    }else{
      if (true === this.reconnect) {
        this.onreconnect()
      }
    }
  }

  /*重连*/
  onreconnect(func) {
    if (this._reconnect_timer) {
      return
    }
    // 确保在重连前清理心跳计时器
    if (this._heart_time) {
      clearInterval(this._heart_time)
      this._heart_time = null
    }
    
    this._reconnect_timer = setInterval(() => {
      if (this.lockReconnect) {
        return
      }
      if (this.reconnectTimes !== null && this.reconnectTimes !== undefined) {
        if (this.reconnectTimes <= 0) {
          // 重连次数用尽，停止重连并清理 timer
          clearInterval(this._reconnect_timer)
          this._reconnect_timer = null
          console.warn('WebSocket reconnect times exhausted, stop reconnecting')
          return
        } else {
          this.reconnectTimes--
        }
      }
      this.lockReconnect = true
      this.token = this._token_func ? this._token_func() : encodeURIComponent(accessToken())
      this.init()
      if (func) func(this)
    }, this.reconnectTime)
  }

  send(text) {
    if (true === this._alive) {
      text = typeof text === 'string' ? text : JSON.stringify(text)
      this.ws.send(text)
    }
  }

  close() {
    // 清理 open 超时计时器
    if (this._open_timeout) {
      clearTimeout(this._open_timeout)
      this._open_timeout = null
    }
    
    if (this.ws) {
      try {
        this.ws.close()
      } catch (e) {
        console.error('close websocket error:{}', e)
      }
      this.ws = null
    }
    this.reconnect = false
    this._alive = false
    this.lockReconnect = false

    if (this._reconnect_timer){
      clearInterval(this._reconnect_timer)
      this._reconnect_timer = null
    }
    if (this._heart_time) {
      clearInterval(this._heart_time)
      this._heart_time = null
    }
    
    // 清理消息缓存和函数引用
    this.messageCache = []
    this._clearMessageHandler()
  }

  // 清理旧的函数引用，防止内存泄漏
  _clearMessageHandler() {
    if (this._message_func) {
      this._message_func = null
    }
  }

  onmessage(func, all = false) {
    // 先清理旧的引用
    this._clearMessageHandler()
    
    // 处理缓存中的消息
    if (this.messageCache.length > 0) {
      const cache = [...this.messageCache]  // 复制一份，避免遍历时修改
      this.messageCache = []  // 立即清空
      cache.forEach(item => {
        try {
          func(!all ? item.data : item)
        } catch (e) {
          console.error('Process cached message error:', e)
        }
      })
    }
    
    // 绑定新的消息处理函数
    this._message_func = func
    const self = this
    if (this.ws) {
      this.ws.onmessage = function(data) {
        try {
          func(!all ? data.data : data)
        } catch (e) {
          console.error('Process message error:', e)
        }
      }
    }
  }

  onopen(func) {
    this.ws.onopen = event => {
      if (this._reconnect_timer) {
        this.lockReconnect = false
        clearInterval(this._reconnect_timer)
        this._reconnect_timer=null
      }
      this._alive = true
      func ? func(event) : false
    }
  }

  onclose(func) {
    this.ws.onclose = event => {
      this._alive = false
      if (this._heart_time) {
        clearInterval(this._heart_time)
        this._heart_time = null
      }
      if (true === this.reconnect) {
        this.onreconnect()
      }
      func ? func(event) : false
    }
  }

  onerror(func) {
    this.ws.onerror = event => {
      this._alive = false
      if (this._heart_time) {
        clearInterval(this._heart_time)
        this._heart_time = null
      }
      if (true === this.reconnect) {
        this.onreconnect()
      }
      func ? func(event) : false
    }
  }
}
export default socket



// WEBPACK FOOTER //
// ./src/api/websocket.js